import { Chart as ChartJS, ChartData, Legend, ArcElement, Tooltip } from "chart.js";
import React, { Fragment } from "react";
import { Pie } from "react-chartjs-2";
import { useLazyLoadQuery } from "react-relay";
import { QUERY } from "./module-rating-details-chart.graphql";
import { moduleRatingDetailsChart_Query } from "../../../../../__generated__/moduleRatingDetailsChart_Query.graphql";

export const ModuleRatingDetailsChart: React.FC<{ id: string }> = ({ id }) => {
	const query = useLazyLoadQuery<moduleRatingDetailsChart_Query>(QUERY, {
		nodeRef: id,
	});

	ChartJS.register(ArcElement, Tooltip, Legend);

	const nodes =
		query.Admin.ModuleRating.ModuleRatingCalculations.edges?.map((e) => e!.node!) ?? [];
	const calc = nodes?.[0]?.scoreMap ?? { one: 0, zero: 0, five: 0, four: 0, three: 0, two: 0 };

	const data: ChartData<"pie"> = {
		labels: [0, 1, 2, 3, 4, 5].map((i) => `${i} Sterne`),
		datasets: [
			{
				label: "# der Bewertungen",
				data: [
					calc.zero && calc.zero,
					calc.one && calc.one,
					calc.two && calc.two,
					calc.three && calc.three,
					calc.four && calc.four,
					calc.five && calc.five,
				],
				backgroundColor: [
					"rgba(255, 99, 132, 0.2)",
					"rgba(54, 162, 235, 0.2)",
					"rgba(255, 206, 86, 0.2)",
					"rgba(75, 192, 192, 0.2)",
					"rgba(153, 102, 255, 0.2)",
					"rgba(255, 159, 64, 0.2)",
				],
			},
		],
	};

	const options = {
		plugins: {
			tooltip: {
				enabled: true,
			},
			legend: {
				display: true,
			},
		},
	};

	if (!calc) return <Fragment />;
	return (
		<div style={{ maxWidth: "400px" }}>
			<Pie data={data} options={options} />
		</div>
	);
};
